<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title14"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9781466826052_tp01" id="toctitle12" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_acknowPage" href="#/e9781466826052_fm01" id="toctitle20" title="Link target outside of Sample"><span>Tor Copyright Notice</span></span><br/>
<a class="toc_entry_acknowPage" href="#/e9781466826052_ack01" id="toctitle1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a><br/><br/>
<a class="toc_entry_chapter" href="#/e9781466826052_c01" id="toctitle2"><span><strong class="b">ONE</strong> - <strong class="b">Strom</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c02" id="toctitle3" title="Link target outside of Sample"><span><strong class="b">TWO</strong> - <strong class="b">Meda</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c03" id="toctitle4" title="Link target outside of Sample"><span><strong class="b">THREE</strong> - <strong class="b">Quant</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c04" id="toctitle5" title="Link target outside of Sample"><span><strong class="b">FOUR</strong> - <strong class="b">Manuel</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c05" id="toctitle6" title="Link target outside of Sample"><span><strong class="b">FIVE</strong> - <strong class="b">Moira</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c06" id="toctitle7" title="Link target outside of Sample"><span><strong class="b">SIX</strong> - <strong class="b">Apollo</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c07" id="toctitle8" title="Link target outside of Sample"><span><strong class="b">SEVEN</strong> - <strong class="b">Apollo</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c08" id="toctitle9" title="Link target outside of Sample"><span><strong class="b">EIGHT</strong> - <strong class="b">Apollo</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466826052_c09" id="toctitle10" title="Link target outside of Sample"><span><strong class="b">NINE</strong> - <strong class="b">Moira Ring</strong></span></span><br/><br/>
<span class="toc_entry_praisePage" href="#/e9781466826052_pra01" id="toctitle11" title="Link target outside of Sample"><span><strong class="b">Praise for Paul Melko</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781466826052_cop01" id="toctitle13" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466826052_toc01.vue?7cfb01db